import { useSelector } from 'react-redux';
import { DrawerContent } from 'components/common/drawer/DrawerContent';
import { FormTextField } from 'components/common/form/Form';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import { addQuoteSchema } from 'validation/form/marketplace';
import { createQuote } from 'store/slices/marketplace';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';

export const NewQuote = (props) => {
  const { close } = props;

  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();

  const loading = useSelector((state) => state.marketplace.newQuoteForm.loading);
  const selectedQuoteSet = useSelector((state) => state.marketplace.selectedQuoteSet);

  const methods = useForm({
    resolver: yupResolver(addQuoteSchema),
    defaultValues: {
      name: '',
    },
  });

  const handleSave = methods.handleSubmit((data) => {
    dispatchAction(createQuote({ id: selectedQuoteSet?.id, form: data }), {
      onSuccess: () => {
        enqueueSnackbar('Quote has been added');
        close();
      },
    });
  });

  return (
    <DrawerContent>
      <DrawerContent.Header title="New Quote" />
      <DrawerContent.Wrapper>
        <DrawerContent.Content>
          <FormProvider {...methods}>
            <FormTextField
              name="name"
              label="Quote Name"
              control={methods.control}
            />
          </FormProvider>
        </DrawerContent.Content>
        <DrawerContent.ActionButtons
          submitButtonText="Create"
          submitButtonLoading={loading}
          submit={handleSave}
          close={close}
        />
      </DrawerContent.Wrapper>
    </DrawerContent>
  );
};
